import {
  Ability,
  AccessTokenData,
  Authority,
  defineAbilityFor as rawDefineAbilityFor,
  RawRuleOf,
  RuleFactory,
  Scope,
  useAbility as rawUseAbility,
} from '@modifi/plugin-authorization'
import {
  CONFIG_KEY_AUTH_TOKEN_AUTHORITIES,
  CONFIG_KEY_AUTH_TOKEN_SCOPE,
  CONFIG_KEY_AUTH_USER_NAME,
} from '@modifi/plugin-authentication'
import {clientConfig} from '@modifi/client-config'

type PluginAdminOnboardingAbilities = ['create' | 'update' | 'get', 'taskActions']

type Abilities = PluginAdminOnboardingAbilities

type AppAbility = Ability<Abilities>

type Rule = RawRuleOf<AppAbility>

const ONBOARDING_WRITE: RuleFactory<Rule> = () => []

const SCOPE_PERMISSION_MAP = new Map<Scope, RuleFactory<Rule>>([
  ['admin:onboarding_write', ONBOARDING_WRITE],
])

const TASK_UNDERWRITING_WRITE: RuleFactory<Rule> = () => [
  {
    action: ['update', 'create'],
    subject: 'taskActions',
  },
]

const TASK_UNDERWRITING_READ: RuleFactory<Rule> = () => [
  {
    action: ['get'],
    subject: 'taskActions',
  },
]

const AUTHORITY_PERMISSIONS_MAP = new Map<Authority, RuleFactory<Rule>>([
  ['tasks:write:underwriting', TASK_UNDERWRITING_WRITE],
  ['tasks:read:underwriting', TASK_UNDERWRITING_READ],
])

export const abilityFactory = (): AppAbility => {
  const user: AccessTokenData = {
    userName: clientConfig.get(CONFIG_KEY_AUTH_USER_NAME) as string,
    scope: clientConfig.get(CONFIG_KEY_AUTH_TOKEN_SCOPE, []) as string[],
    authorities: clientConfig.get(CONFIG_KEY_AUTH_TOKEN_AUTHORITIES, []) as string[],
  }

  return rawDefineAbilityFor<Abilities>(
    user,
    {},
    {authorityPermissions: AUTHORITY_PERMISSIONS_MAP, scopePermissions: SCOPE_PERMISSION_MAP}
  )
}

export const useAbility = (): AppAbility => rawUseAbility<AppAbility>()
